export * from './checkIfPresentedAsModalWithoutHeader';
